import { Alert } from '@mantine/core'
import type { FlashData } from '@/types'

type FlashMessagesProps = {
  flash?: FlashData
}

export default function FlashMessages({ flash }: FlashMessagesProps) {
  if (!flash?.notice && !flash?.alert) return null

  return (
    <>
      {flash.notice ? (
        <Alert color="teal" title="Success" variant="light">
          {flash.notice}
        </Alert>
      ) : null}
      {flash.alert ? (
        <Alert color="red" title="Attention" variant="light">
          {flash.alert}
        </Alert>
      ) : null}
    </>
  )
}
